
export const GroupTypeConstant = {
    GroupType: 'api/GroupType',  
};